import { render, staticRenderFns } from "./StaffPersonModal.vue?vue&type=template&id=39cc42e2&scoped=true"
import script from "./StaffPersonModal.vue?vue&type=script&lang=js"
export * from "./StaffPersonModal.vue?vue&type=script&lang=js"
import style0 from "./StaffPersonModal.vue?vue&type=style&index=0&id=39cc42e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cc42e2",
  null
  
)

export default component.exports